/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EventsControllerDtoBannerRemoveRequest model module.
 * @module model/EventsControllerDtoBannerRemoveRequest
 * @version 1.0
 */
class EventsControllerDtoBannerRemoveRequest {
    /**
     * Constructs a new <code>EventsControllerDtoBannerRemoveRequest</code>.
     * @alias module:model/EventsControllerDtoBannerRemoveRequest
     */
    constructor() { 
        
        EventsControllerDtoBannerRemoveRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoBannerRemoveRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoBannerRemoveRequest} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoBannerRemoveRequest} The populated <code>EventsControllerDtoBannerRemoveRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoBannerRemoveRequest();

            if (data.hasOwnProperty('bannerNo')) {
                obj['bannerNo'] = ApiClient.convertToType(data['bannerNo'], ['Number']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoBannerRemoveRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoBannerRemoveRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is an array
        if (!Array.isArray(data['bannerNo'])) {
            throw new Error("Expected the field `bannerNo` to be an array in the JSON data but got " + data['bannerNo']);
        }

        return true;
    }


}



/**
 * @member {Array.<Number>} bannerNo
 */
EventsControllerDtoBannerRemoveRequest.prototype['bannerNo'] = undefined;






export default EventsControllerDtoBannerRemoveRequest;

